import script from "./BaseHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseHeader.vue?vue&type=script&setup=true&lang=ts"

import "./BaseHeader.vue?vue&type=style&index=0&id=efe342b0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efe342b0"]])

export default __exports__